import type { DateRange } from 'react-day-picker';

export function startOfLocalDay(date: Date): Date {
  const next = new Date(date);
  next.setHours(0, 0, 0, 0);
  return next;
}

export function isSameLocalMonth(left: Date, right: Date): boolean {
  return (
    left.getFullYear() === right.getFullYear() && left.getMonth() === right.getMonth()
  );
}

/**
 * First month of a calendar window that ends on `today`, matching
 * `DateRangePanel`: one month shows today; two months show last month
 * then today.
 */
export function monthWindowStartForToday(today: Date, numberOfMonths: number): Date {
  const offset = Math.max(numberOfMonths, 1) - 1;
  return new Date(today.getFullYear(), today.getMonth() - offset, 1);
}

export function selectToday(mode: 'range', today?: Date): DateRange;
export function selectToday(mode?: 'single', today?: Date): Date;
export function selectToday(
  mode: 'single' | 'range' = 'single',
  today: Date = new Date()
): Date | DateRange {
  const day = startOfLocalDay(today);
  if (mode === 'range') {
    return { from: day, to: undefined };
  }
  return day;
}
